import React, { useState } from "react"
import SbEditable from "storyblok-react"
import Components from "../components"
import GlobalHeader from "../components/global-header/GlobalHeader"
import Header from "../components/header"
import CrumbTrail from "../components/crumb-trail"
import Footer from "../components/footer"
import S22FooterWrapper from "../components/s22_footer/FooterWrapper"
import CookieNotice from "../components/cookie-notice"
import SubNav from "../components/sub-nav"
import Navigation from "../components/navigation"
import MetaData from "../components/meta-data"
import StructuredData from "../components/structuredMarkup"
import getSectionsAnchors from "../helpers/handleSectionAnchors"
import { pageBlokType, globalDataType } from "../types"
import OverlayCmp from "../components/s22_overlay"

interface PageLayoutProps {
  globalData: globalDataType
  blok: pageBlokType
  path: string
}

const PageLayout: React.FC<PageLayoutProps> = ({ globalData, blok, path }) => {


  return (
    <>
        <OverlayCmp  />
        {blok.header &&
          blok.header.filter((content) => content.component === "global_header")
            .length > 0 ? null : path.includes("executive-education") ? (
              <Header blok={globalData} />
            ) : (
          <GlobalHeader blok={globalData} fixHeight={true} />
        )}
        <SbEditable content={blok}>
          {blok.meta_data &&
            blok.meta_data.map((md) => {
              if (md.component === "meta_data")
                return <MetaData key={md._uid} meta_data={md} path={path} />
              if (md.component === "structuredMarkup")
                return <StructuredData key={md._uid} blok={md} />
              return null
            })}
          <div className="full-container">
            {blok.header &&
              blok.header.map((content) => {
                if (content.component === "subNav") {
                  return (
                    <SubNav
                      key={content._uid}
                      blok={content}
                      anchorList={getSectionsAnchors(blok.body)}
                    />
                  )
                }
                if (content.component === "navigation") {
                  return (
                    <Navigation
                      key={content._uid}
                      blok={content}
                      anchorList={getSectionsAnchors(blok.body)}
                    />
                  )
                }
                return React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                  path: content.component === "global_header" ? path : undefined,
                })
              })}
            {blok.body &&
              blok.body.map((content) => {
                return React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              })}
          </div>
        </SbEditable>
        {globalData.crumb_trail &&
          globalData.crumb_trail.map((crumb_trail) => (
            <CrumbTrail key={crumb_trail._uid} blok={crumb_trail} />
          ))}

        {path.includes("executive-education") ? (
          globalData.footer &&
          globalData.footer.map((footer) => (
            <Footer key={footer._uid} blok={footer} />
          ))
        ) : (
          <S22FooterWrapper />
        )}

        {globalData.cookie_notice &&
          globalData.cookie_notice.map((cookie_notice) => (
            <CookieNotice blok={cookie_notice} key={cookie_notice._uid} />
          ))}
    </>
  )
}

export default PageLayout
